import { useEffect, useState } from 'react';
import Input from '../../components/inputComponent/Input';
import axios from 'axios';
import { apiPath, baseUrl } from '../../global';
import '../login/Login.css';
import bgImg from '../../assets/icons/loginImage/image2.webp';
import { toast } from 'react-toastify';
import logo from '../../assets/logo/sanaLogo.png';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function ResetPassword() {

    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    let key = searchParams.get("key");

    useEffect(() => {
        
        if(key === null || key === undefined || key === ''){
            navigate('/');
        }
    })

    const handleReset = (e) => {
        e.preventDefault();

        setLoading(true);
        const id = toast.loading("Please wait...");
        
        axios.put(`${apiPath}/general/resetPassword`, {
            newPassword: e.target.password.value,
            resetKey: key
        }, {headers: {"Authorization":''}}).then(async res => {
            if(res.data.success)
            {
                toast.update(id, { render: res.data.message, type: "success", isLoading: false , autoClose: true, closeButton: true});
            }
            else{
                toast.update(id, { render: res.data.message, type: "error", isLoading: false , autoClose: true, closeButton: true});
            }
        }).catch(err => {
            console.log(err);
            
            toast.update(id, { render: err.message, type: "error", isLoading: false , autoClose: true, closeButton: true});
        }).finally(() =>{
            
            setLoading(false);
            navigate('/');
        })
    }

  return (
    <div className='login-main' style={{backgroundImage:`url(${bgImg})`, backgroundRepeat:'no-repeat', backgroundPosition:'center', backgroundSize:'cover'}}>
        
        <div className='custom-card login-card' style={{paddingBottom:'40px'}}>
            <img loading='lazy' src={logo} style={{marginBottom: '40px'}}/>
            {/* <h2 style={{textAlign:'center', marginTop:'10px', marginBottom:'40px'}}>Logo Here</h2> */}
            <form className='login-form' onSubmit={handleReset}>
                <Input type='password' placeholder="Enter New Password" name="password" style={{marginBottom: '10px'}}/>
                <Input type='submit' value={"Reset"} disabled={loading} />
            </form>

        </div>

    </div>
  )
}
